import styled, { css } from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;
  width: 100%;
  background: var(--white-dark);
  display: flex;
  flex-direction: column;

  .search-info {
    display: flex;
    align-items: center;
    justify-content: space-between;

    color: var(--black-2);
  }

  color: var(--black-2);

  @media (max-width: 800px) {
    padding: 0;
  }
`;

export const Content = styled.div`
  height: 100%;
  width: 100%;
  padding: 40px 30%;

  @media (max-width: 800px) {
    padding: 32px 24px;
  }
`;

export const NotFoundContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px 0;
  color: var(--gray-9);

  svg {
    margin-right: 8px;
  }
`;

export const SelectAllButton = styled.button`
  display: flex;
  align-items: center;

  padding: 4px 10px;
  border-radius: 8px;
  background: transparent;
  font-weight: 500;
  font-size: 14px;
  color: var(--black-7);
  margin-top: 16px;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  #dot {
    height: 24px;
    width: 24px;
    border: 1px solid var(--gray-e);
    background: var(--white);
    border-radius: 50%;
    margin-right: 8px;
    position: relative;

    span {
      content: '';
      background: var(--info);
      height: 14px;
      width: 14px;
      border-radius: 50%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;

export const SelectedAnimalsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  position: fixed;

  width: 100%;
  height: 80px;
  padding: 16px 20%;

  bottom: 0;
  right: 0;

  background: var(--white-dark);
  border-top: 1px solid var(--gray-e);

  > button {
    padding: 12px 32px;
    font-size: 16px;
    font-weight: 500;
    background: var(--primary);
    color: var(--white);
    border-radius: 16px;
    cursor: pointer;
  }

  @media (max-width: 800px) {
    padding: 16px 24px;
  }
`;
